import { request } from './utils';

const serializeProspect = (data) => {
  const serializedData = {
    ...data,
    phoneCountry: data?.phoneCountry?.id,
  };
  return serializedData;
};

const serializeProspectCall = (data) => {
  const serializedData = {
    ...data,
    timezone: data?.timezone?.id,
    preferred: data?.preferred?.id,
  };
  return serializedData;
};

export const postProspect = async (data, serializer = serializeProspect, config = undefined) => {
  const url = `public/prospects/`;
  return await request.post(url, serializer(data), config);
};

export const getProspect = async (uuid, config = undefined) => {
  const url = `public/prospects/${uuid}/`;
  return await request.get(url, config);
};

export const putProspect = async (
  uuid,
  data,
  serializer = serializeProspect,
  config = undefined
) => {
  const url = `public/prospects/${uuid}/`;
  return await request.put(url, serializer(data), config);
};

export const updateProspectRequirement = async (uuid, data, config = undefined) => {
  const url = `public/prospects/${uuid}/`;
  return await request.put(url, data, config);
};

export const postProspectRequirementLink = async (uuid, data, config = undefined) => {
  const url = `public/prospects/${uuid}/links/`;
  return await request.post(url, data, config);
};

export const postProspectRequirementFile = async (uuid, data, config = undefined) => {
  const url = `public/prospects/${uuid}/attachments/`;
  return await request.post(url, data, config);
};

export const deleteProspectRequirementLink = async (uuid, linkId, config = undefined) => {
  const url = `public/prospects/${uuid}/links/${linkId}/`;
  return await request.delete(url, config);
};

export const deleteProspectRequirementFile = async (uuid, fileId, config = undefined) => {
  const url = `public/prospects/${uuid}/attachments/${fileId}/`;
  return await request.delete(url, config);
};

export const getProspectCallGoogleLink = async (uuid, config = undefined) => {
  const url = `public/prospects/${uuid}/call/generate-gcal`;
  return await request.get(url, config);
};

export const getProspectCallOutlookLink = async (uuid, config = undefined) => {
  const url = `public/prospects/${uuid}/call/generate-outlook`;
  return await request.get(url, config);
};

export const getProspectCallLink = async (uuid, config = undefined) => {
  const url = `public/prospects/${uuid}/call/generate-ics`;
  return await request.get(url, config);
};

export const postProspectCall = async (
  uuid,
  data,
  serializer = serializeProspectCall,
  config = undefined
) => {
  const url = `public/prospects/${uuid}/calls/`;
  return await request.post(url, serializer(data), config);
};

export const putProspectCall = async (
  uuid,
  callId,
  data,
  serializer = serializeProspectCall,
  config = undefined
) => {
  const url = `public/prospects/${uuid}/calls/${callId}/`;
  return await request.put(url, serializer(data), config);
};

export const patchProspectCall = async (
  uuid,
  callId,
  data,
  serializer = serializeProspectCall,
  config = undefined
) => {
  const url = `public/prospects/${uuid}/calls/${callId}/`;
  return await request.patch(url, serializer(data), config);
};

export const getProspectCall = async (uuid, callId, config = undefined) => {
  const url = `public/prospects/${uuid}/calls/${callId}/`;
  return await request.get(url, config);
};
